import React from "react";
import "./Footer.css";
export default function Footer() {
  return (
    <footer className="Footer">
      <a
        className="codeLink"
        target="_blank"
        rel="noreferrer"
        href="https://github.com/12Isabella/weather-react-CandyLu"
      >
        open source code{" "}
      </a>
      by Isabella Otto
    </footer>
  );
}
